<template>
	<div class="house">
		<div class="group-content">
			<van-swipe-cell
				v-for="(item,ind) in repairList"
				:key="ind">

				<van-card
					:desc="item.remark||''"
					:style="'margin-bottom:10px;'"
				>
					<template #title>
						<span style="font-weight:bold;">{{item.title}}</span>
					</template>
					<template #tags v-if="item.imgs">
						<div :style="{'padding':'5px 2px'}">
							<img :src="attach_url+uri" v-for="(uri,i) in item.imgs.split(',')" :key="i" :style="{height:'30px','margin-right':'5px'}" @click.stop="previewImg(item.imgs, i)"/>
						</div>
					</template>
					<template #price>
						始于 {{item.times_repair?item.times_repair:item.times_start}} {{item.times_end?('，结束于 '+item.times_end):''}}
					</template>
				</van-card>

				<template #right>
					<van-button square text="编辑" type="primary" @click="onEditHouseRepair(item.id)" v-if="!readonly"/>
					<van-button square text="删除" type="danger" @click="onDelHouseRepair(item.id)" v-if="!readonly"/>
				</template>

			</van-swipe-cell>
			<div class="empty" v-if="repairList.length==0">
				<span class="msg">没有相关信息！</span>
			</div>
		</div>

		<van-popup v-model="showEditHouseRepair" round position="bottom" :style="{ 'max-height': '80%', 'bottom':'50px', 'padding-top':'20px'}">
			<van-cell-group > 
				<van-field
					v-model.trim="repairInfo.title"
					label="修葺简要："
					placeholder="请输入简要内容"
					required
					clearable
				></van-field>
				<van-cell title="修葺时间：" title-class="van-field__label">
					<template #default>始于 {{repairInfo.times_repair?repairInfo.times_repair:repairInfo.times_start}} {{repairInfo.times_end?('，结束于 '+repairInfo.times_end):''}}</template>
					<template #right-icon><van-button type="default" plain hairline size="mini" @click.stop="showPopup2HouseRepairTime" :style="{'margin-left':'5px'}">选 / 填</van-button></template>
				</van-cell>

				<van-field
				  v-model.trim="repairInfo.remark"
				  rows="5"
				  label="修葺备注："
				  type="textarea"
				  maxlength="3000"
				  placeholder="请输入备注内容"
				  show-word-limit
				/>

				<van-cell title="图片：" title-class="van-field__label">
					<template #default>
						<van-uploader ref="clansHouseRepairUploader" v-model="imgList" max-count="5" :max-size="imgSizeLimit" @oversize="onOversize" :before-read="beforeRead"/>
					</template>
				</van-cell>


				<van-row  :style="{'margin-bottom':'10px'}">
					<van-col span="1"></van-col>
					<van-col span="9">
						<van-button type="default" block  @click="showEditHouseRepair=false">取消</van-button>
					</van-col>
					<van-col span="1"></van-col>
					<van-col span="12">
						<van-button type="primary" block  @click="onSaveHouseRepair">保存</van-button>
					</van-col>
					<van-col span="1"></van-col>
				</van-row> 

			</van-cell-group>

		</van-popup>

		<van-popup v-model="showHouseRepairTimePopup" position="bottom" :style="{'min-height':'200px', 'bottom':'50px'}">

			<van-row  :style="{'margin-bottom':'10px'}">
				<van-col span="5">
					<van-sidebar v-model="sidebarActiveKey">
						<van-sidebar-item title="选择日期" />
						<van-sidebar-item title="手动输入" />
					</van-sidebar>
				</van-col>
				<van-col span="19">
					<van-cell-group > 
						<van-field
							v-model.trim="repairInfo.times_repair"
							label=""
							placeholder="请输入修葺时间"
							clearable
						v-if="sidebarActiveKey==1"
						></van-field>

						<van-cell
							title="开始日期："
							is-link
							:value="repairInfo.times_start"
							title-class="van-cell-title"
							v-if="sidebarActiveKey==0"
							@click="showHouseRepairTimePicker=1"
						>
							<template #right-icon>
								<van-icon name="arrow" class="van-cell__right-icon" />
								<van-button type="default" plain hairline size="mini" @click.stop="repairInfo.times_start=''" :style="{'margin-left':'5px'}">置空</van-button>
							</template>
						</van-cell>
						<van-cell
							title="完工日期："
							is-link
							:value="repairInfo.times_end"
							title-class="van-cell-title"
							v-if="sidebarActiveKey==0"
							@click="showHouseRepairTimePicker=2"
						>
							<template #right-icon>
								<van-icon name="arrow" class="van-cell__right-icon" />
								<van-button type="default" plain hairline size="mini" @click.stop="repairInfo.times_end=''" :style="{'margin-left':'5px'}">置空</van-button>
							</template>
						</van-cell> 
					</van-cell-group > 
				</van-col>
			</van-row> 
			<van-row  :style="{'margin-bottom':'10px'}" v-if="sidebarActiveKey==0&&showHouseRepairTimePicker>0">
				<van-col span="24">
					<van-cell-group>

						<van-datetime-picker
							type="date"
							:title="showHouseRepairTimePicker==1?'开始日期':'完工日期'"
							:min-date="new Date(1900, 0, 1)"
							:max-date="new Date()"
							
							@confirm="onConfirmHouseRepairTime"
							@cancel="showHouseRepairTimePicker=0"
						/>
					</van-cell-group > 
				</van-col>
			</van-row> 
			<van-row  :style="{'margin-bottom':'10px'}">
				<van-col span="1"></van-col>
				<van-col span="22">
					<van-button type="primary" block  @click="showHouseRepairTimePopup=false" :disabled="sidebarActiveKey==0&&showHouseRepairTimePicker>0">确定</van-button>
				</van-col>
				<van-col span="1"></van-col>
			</van-row> 
			
		</van-popup>

		<van-button square text="新增" type="default" class="btn_add" @click="onAddHouseRepair" v-if="!readonly"/>


	</div>
</template>

<script>
import {Card, SwipeCell, Sidebar, SidebarItem, DatetimePicker,ImagePreview } from "vant";
import { chkImgType } from "@/utils/common.js";

export default {
	name: "clans_house_repair",
	components: {
		"van-card":Card,
		"van-swipe-cell":SwipeCell,
		"van-sidebar":Sidebar,
		"van-sidebar-item":SidebarItem,
		"van-datetime-picker":DatetimePicker
	},
	props:{
		h_id:Number,
		readonly:Boolean
	},
	data() {
		return {
			title: "置业修葺信息管理",
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			attach_url:this.Conf.serverPre,

			repairList:[],
			repairInfoObj:{},
			showEditHouseRepair:false,
			repairInfo:{},
			showHouseRepairTimePopup:false,
			sidebarActiveKey:0,
			showHouseRepairTimePicker:0,
			
			imgList:[],
			imgSizeLimit:500 * 1024,
			saveFlag:false,
	
			repairId:0,
			showHouseRepairPopup:false
		};
	},
	created() {
		this.getStateConfigs();
		this.getHouseRepairData();
		
	},
	computed: {
	},
	methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		beforeRead(file){
			return chkImgType(file);
		},
		onOversize(){
			this.$toast.fail("图片大小不能超过 500kb");
		},
		getHouseRepairData(){
			var params = {
				u_id:this.u_id,
				token:this.token,
				h_id:this.h_id,
			};
			let that = this;
			var url = this.Conf.serverUrl + "clans/personalHouseRepair" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				that.repairList = [];
				that.repairInfoObj = {};
				let datas = response.data.datas;
				if(datas && datas.length > 0){
					that.repairList = datas;
					for(var i=0,il=datas.length; i<il; i++){
						that.repairInfoObj[datas[i]['id']] = datas[i];
					};
				}
			})
			.catch(error => {});
		},
		showPopup2HouseRepairTime(){
			this.showHouseRepairTimePopup = true;
			this.sidebarActiveKey = this.repairInfo.times_repair?1:0;
		},
		onAddHouseRepair(){
			this.repairInfo = {h_id:this.h_id};
			this.imgList = [];
			this.showEditHouseRepair = true;
		},
		onEditHouseRepair(id){
			this.repairInfo = this.repairInfoObj[id];
			this.imgList = [];
			this.showEditHouseRepair = true;
			if(this.repairInfo.imgs){	
				let imgs = this.repairInfo.imgs.split(',');
				for(var i=0,il=imgs.length; i<il; i++){
					this.imgList.push({url:imgs[i].indexOf('http')==-1?(this.attach_url+imgs[i]):imgs[i], isImage: true});
				}
			}
			
		},
		onDelHouseRepair(id){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "删除后将不可恢复，确定？",
			})
			.then(() => {
				var params = {
					u_id:this.u_id,
					token:this.token,
					id:id,
					h_id:this.h_id
				};
				let that = this;
				var url = this.Conf.serverUrl + "clans/personalHouseRepairDel" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					that.$toast.success(response.data.msg);
					if(response.data.code == 200){
						that.getHouseRepairData();
					}
				})
				.catch(error => {});
			})
			.catch((error) => {});
		},
		onSaveHouseRepair(){
			if(this.saveFlag){
				this.$toast.fail("请求尚未响应，请勿重复提交！");
				return false;
			}
			if(!this.repairInfo['title']){
				this.$toast.fail("请输入修葺简要！");
				return false;
			}
			this.saveFlag = true;
			let phs = null;
			if(this.imgList.length > 0){
				this.repairInfo['new_imgs'] = [];
				for(var i=0,il=this.imgList.length; i<il; i++){
					if(this.imgList[i].content){
						this.repairInfo['new_imgs'].push(this.imgList[i].content);
					}else{
						phs = this.imgList[i].url.split("/");
						this.repairInfo['new_imgs'].push(phs[phs.length-1]);
					}
				}
			}
			var params = {
				u_id:this.u_id,
				token:this.token,
				data:this.repairInfo
			};
			let that = this;
			var url = this.Conf.serverUrl + "clans/personalHouseRepairSave" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				that.saveFlag = false;
				that.showHouseRepairTimePopup = false;
				that.showEditHouseRepair = false;
				that.$toast.success(response.data.msg);
				if(response.data.code == 200){
					that.getHouseRepairData();
				}
			})
			.catch(error => {});
		},
		onConfirmHouseRepairTime(val){
			if(this.showHouseRepairTimePicker==1){
				this.repairInfo.times_start = this.$options.filters['moment_format'](val.getTime(),'Y-MM-DD');
			}else{
				this.repairInfo.times_end = this.$options.filters['moment_format'](val.getTime(),'Y-MM-DD');
			}
			this.showHouseRepairTimePicker=0;
			this.$forceUpdate();
		},
		previewImg(imgs, i){
			imgs = imgs.split(",");
			var imgarr = [];
			for(var ii in imgs){
				imgarr.push(this.attach_url+imgs[ii]);
			}
			ImagePreview({
				images: imgarr,
				startPosition: i,
				showIndex:false,
				showIndicators:true
			});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Clans/HouseRepair.vue